'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _CartTable = require('../components/CartTable');

var _CartTable2 = _interopRequireDefault(_CartTable);

var _CartSummary = require('../components/CartSummary');

var _CartSummary2 = _interopRequireDefault(_CartSummary);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

require('linksoft-albatros/src/plugins/jquery.sticky-fit');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        cart: state.cart
    };
}

var mapDispatchToProps = {
    update: _actions2.default.update
};

var CartDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
    (0, _inherits3.default)(CartDetail, _Component);

    function CartDetail() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CartDetail);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CartDetail.__proto__ || (0, _getPrototypeOf2.default)(CartDetail)).call.apply(_ref, [this].concat(args))), _this), _this.applyChanges = function (item) {
            var change = _this.props.cart.changes[item.productId];
            var changed = !!change;
            var ret = (0, _assign2.default)({}, item, {
                changed: changed,
                amount: changed ? change.amount : item.amount,
                displayAmount: changed ? change.displayAmount : item.amount,
                origAmount: item.amount
            });
            return ret;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CartDetail, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var initialProps = this._root.parentNode.attributes['data-component-props'];
            if (initialProps && initialProps.value) {
                var initialState = JSON.parse(initialProps.value);
                this._root.parentNode.removeAttribute('data-component-props');
                if (initialState && initialState.cart) {
                    this.props.update(initialState.cart);
                }
            }
        }
    }, {
        key: 'sortSwitcher',
        value: function sortSwitcher(a, b) {
            var typeA = typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a);
            var typeB = typeof b === 'undefined' ? 'undefined' : (0, _typeof3.default)(b);
            if (typeA === 'string') {
                return a.localeCompare(b);
            } else if ((typeA === "number" || typeA === "int") && (typeB === "number" || typeB === "int")) {
                return Math.round(a - b);
            } else {
                return 1;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$cart = this.props.cart,
                totalPrice = _props$cart.totalPrice,
                canChangeCart = _props$cart.canChangeCart,
                canSeeRabat = _props$cart.canSeeRabat,
                _props$cart$items = _props$cart.items,
                items = _props$cart$items === undefined ? [] : _props$cart$items,
                sortByProp = _props$cart.sortByProp,
                sortDirection = _props$cart.sortDirection;


            sortByProp = sortByProp || 'name';
            sortDirection = sortDirection || 'asc';

            var tableArgs = {
                totalPrice: totalPrice,
                canChangeCart: canChangeCart,
                canSeeRabat: canSeeRabat,
                sortByProp: sortByProp,
                sortDirection: sortDirection,
                items: items.map(this.applyChanges),
                cart: this.props.cart
            };

            if (sortByProp) {
                tableArgs.items = tableArgs.items.sort(function (a, b) {
                    return sortDirection !== 'desc' ? _this2.sortSwitcher(a[sortByProp], b[sortByProp]) : _this2.sortSwitcher(b[sortByProp], a[sortByProp]);
                });
            }

            // render entire cart
            return _react2.default.createElement(
                'div',
                { className: 'row', ref: function ref(e) {
                        return _this2._root = e;
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 col-lg-9' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row userInfo' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-12' },
                            _react2.default.createElement(_CartTable2.default, tableArgs)
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 col-lg-3 rightSidebar' },
                    _react2.default.createElement(_CartSummary2.default, null)
                )
            );
        }
    }]);
    return CartDetail;
}(_react.Component)) || _class);


CartDetail.propTypes = {
    cart: _propTypes2.default.object.isRequired
};

exports.default = CartDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/cart-detail.js
// module id = 912
// module chunks = 0